import { subscription } from '@/api/payment';

export default {
  namespaced: true,
  state: {
    createLoading: false,
    saveLoading: false,
    updateLoading: false,
    findCreatorLoading: false,
  },
  mutations: {
    setCreateLoading(state, isLoading) {
      state.createLoading = isLoading;
    },
    setSaveLoading(state, isLoading) {
      state.saveLoading = isLoading;
    },
  },
  actions: {
    async create({ commit, dispatch, rootGetters }, { paymentData, paymentMethod }) {
      try {
        commit('setCreateLoading', true);

        const { data: subscriptionCreationResponse } = await subscription.create(paymentData);
        const {
          status,
          clientSecret,
        } = subscriptionCreationResponse;

        if (status !== 'active') {
          const stripe = rootGetters['payment/stripe/stripe'];
          const { error } = await stripe.confirmCardPayment(clientSecret, { payment_method: paymentMethod });

          if (error) throw error;
        }

        await dispatch('payment/stripe/redirectToSuccessPage', {}, { root: true });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setCreateLoading', false);
      }
    },
    async save({ commit, dispatch }, obj) {
      try {
        commit('setSaveLoading', true);
        const { data } = await subscription.save(obj);
        return data;
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setSaveLoading', false);
      }
    },
  },
  getters: {
    createLoading: state => state.createLoading,
    saveLoading: state => state.saveLoading,
  },
};
